import React from 'react';
import { customsOfficer } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Customs and immigration',
  synonyms: 'officer',
  group: 'standardMarker',
  typeUrl: 'customsAndImmigration',
  icon: {
    baseShape: customsOfficer,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'customsAndImmigrationMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Customs and immigration',
      itemTitleFunction: (item) =>
        (item && item.title) || 'Customs and immigration',
    },
    creationOptions: {
      menuText: 'Customs and immigration',
      newTitle: 'Customs and immigration',
      titlePlaceholder: 'Name of marker',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate a place where you can clear customs or
          immigration. Include information such as who to contact and other
          guidance that may be helpful.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        {
          label: 'Advance notice required (check official website for details)',
          isActive: false,
        },
        { label: 'Marina (clearance organised by marina)', isActive: false },
        {
          label: 'Dock / Wharf (clearance carried out on public wharf / dock)',
          isActive: false,
        },
        { label: 'Anchorage (anchor and contact officials)', isActive: false },
        { label: 'Fees apply', isActive: false },
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Customs and immigration',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
